var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobilePreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.138,
    height: 63.9,
    viewBox: "0 0 62.138 63.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-4 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M65,33.9a42.465,42.465,0,0,0-12.3-9.5V11.5A8.493,8.493,0,0,0,44.2,3H12.5A8.493,8.493,0,0,0,4,11.5V58.4a8.493,8.493,0,0,0,8.5,8.5H44.3a8.493,8.493,0,0,0,8.5-8.5V48.8a42.152,42.152,0,0,0,12.3-9.5A3.9,3.9,0,0,0,65,33.9ZM34.7,8.1l-1.2,3.8H23.2L22,8.1Zm13,50.4A3.543,3.543,0,0,1,44.2,62H12.4a3.543,3.543,0,0,1-3.5-3.5v-47A3.543,3.543,0,0,1,12.4,8h4.2l1.9,5.8a4.416,4.416,0,0,0,4.2,3H33.9a4.416,4.416,0,0,0,4.2-3L40,8.1h4.2a3.543,3.543,0,0,1,3.5,3.5v11a3.553,3.553,0,0,0-1-.2c-.3-.1-.6-.1-.9-.2a5.019,5.019,0,0,0-1.2-.2,1.268,1.268,0,0,1-.6-.1c-.6,0-1.1-.1-1.7-.1h-.1c-10.7,0-19.5,8.4-22.7,12.1a4.126,4.126,0,0,0,0,5.5c3.3,3.6,12,12,22.7,12h.3a7.084,7.084,0,0,0,1.4-.1,1.7,1.7,0,0,0,.7-.1c.3,0,.6-.1.9-.1.6-.1,1.2-.2,1.7-.3a.367.367,0,0,0,.3-.1v7.8ZM49,45c-.4.2-.9.3-1.3.5-.1,0-.3.1-.4.1-.5.1-.9.3-1.4.4a.367.367,0,0,0-.3.1c-.5.1-1.1.2-1.6.3h-.1a9.7,9.7,0,0,1-1.7.1c-8.3,0-15.6-6.8-18.4-9.7C26.6,33.9,33.9,27,42.2,27a8.6,8.6,0,0,1,1.6.1.756.756,0,0,1,.4.1c.4.1.9.1,1.3.2.2,0,.3.1.5.1l1.2.3c.2.1.4.1.6.2.4.1.7.3,1.1.4,5.4,2.1,9.8,6.3,11.8,8.4-2,2-6.4,6.1-11.7,8.2Z",
    fill: "#ef6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M46.1,35.1a2.506,2.506,0,0,0-.4-.7,4.313,4.313,0,0,0-1.1-1.1c-.2-.1-.5-.3-.7-.4a1.884,1.884,0,0,0-.8-.2,4.165,4.165,0,0,0-3.7,1.1,4,4,0,0,0-1.2,2.9,3.847,3.847,0,0,0,1.2,2.9,4,4,0,0,0,2.9,1.2,2.2,2.2,0,0,0,.8-.1,2.353,2.353,0,0,0,.8-.2,2.506,2.506,0,0,0,.7-.4,2.651,2.651,0,0,0,.6-.5,4,4,0,0,0,1.2-2.9,2.2,2.2,0,0,0-.1-.8A1.884,1.884,0,0,0,46.1,35.1Z",
    fill: "#ef6f6f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePreviewIcon);
export default __webpack_public_path__ + "static/media/mobile_preview_icon.5b4dc0c23576449618af740dac45194f.svg";
export { ForwardRef as ReactComponent };